import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, switchMap, take, tap } from 'rxjs';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { environment } from 'environments/environment';
import { CrudService } from 'app/services/crud.service';
import { AppConfigService } from 'app/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends CrudService<any> {

  constructor(private config: AppConfigService, http: HttpClient) {
    super(config.NotificationsUrl, http);
  }
  get_notifications(): Observable<any> {
    let url = `${this.config.NotificationsUrl}/viajes-pendientes`;
    return this.http.get<any>(url);
  }


}
